/**
 * Bare `uuid` shim. Under Yarn PnP, Rolldown doesn't apply uuid@3's `browser`-field
 * remap, so uuid@3 consumers pull its Node `crypto` RNG into the browser (throws at
 * runtime). We alias bare `uuid` to one uuid@9 browser build (`uuid-real`) instead;
 * uuid@9 is named-only ESM, so restore a callable default (= `v4`) for consumers
 * that call `uuid()`. Not a Rolldown interop limitation; node-modules apps don't hit it.
 *
 * `uuid-real` is defined in the vite config (aliasing bare `uuid` here would loop).
 */
import { v1, v3, v4, v5, NIL, parse, stringify, validate, version } from 'uuid-real';

// Loaded through Vite aliases, which static analysis cannot trace.
// fallow-ignore-next-line unused-export
export { v1, v3, v4, v5, NIL, parse, stringify, validate, version };
// fallow-ignore-next-line unused-export
export default v4;
